var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZoomInLine = function SvgZoomInLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m17.928 16.155 3.855 3.854-1.274 1.274-3.854-3.855A8.06 8.06 0 0 1 11.6 19.2a8.103 8.103 0 0 1-8.1-8.1C3.5 6.629 7.129 3 11.6 3s8.1 3.629 8.1 8.1a8.06 8.06 0 0 1-1.772 5.055m-1.806-.668A6.28 6.28 0 0 0 17.9 11.1c0-3.481-2.82-6.3-6.3-6.3a6.3 6.3 0 0 0-6.3 6.3c0 3.48 2.819 6.3 6.3 6.3a6.28 6.28 0 0 0 4.388-1.777zM10.7 10.2V7.5h1.8v2.7h2.7V12h-2.7v2.7h-1.8V12H8v-1.8z"
  })));
};
export default SvgZoomInLine;